;(function () {

"use strict";

var FormView = require('./form');

var MetafieldsFormView = FormView.extend({
  initialize: function (opts) {
    opts = opts || {};
    this.url = opts.url || "/detail/" + window.data.type + '/' + window.data.object.id;

    FormView.prototype.initialize.call(this, opts);

    window.App.Events.on('submit', _.bind(this.save, this));
  },
  formatData: function () {
    var data = new FormData();
    var obj = {};

    this.inputs.map(function (input) {
      var key = input.name;
      var val = input.val();
      var id = input.$el.data('metafield-id');
      var datatype = input.$el.closest('.row').data('datatype');

      if (input.iuv) {
        /* Images have to be sent seperately */
        _.each(val, function (image) {
          if (input.iuv.filename) { 
            data.append(key, image, input.iuv.filename);
          }
        });

        if (input.val()[0]) {
          obj[key] = {
            id: id,
            datatype: datatype
          };
        }
      } else {
        // obj[key] = val;
        if (val) {
          obj[key] = {
            value: val,
            id: id,
            datatype: datatype
          };
        }
      }
    });

    obj.__shop__ = window.data.shop;
    data.append('json', JSON.stringify(obj));

    return data;
  },
  save: function (e) {
    FormView.prototype.save.call(this, e);
    if (!this.valid) { console.log('form not valid'); return; }

    var data = this.formatData();

    /* Ajax fails for some images on chrome & safari (not sure why, this solved it...) */
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("load", _.bind(this.saved, this));

    var url = this.url;

    xhr.open("POST", url);
    xhr.setRequestHeader("Authorization", "Bearer " + window.sessionToken);

    xhr.send(data);

    ShopifyApp.Bar.loadingOn();
  },
  saved: function (d) {
    var target = d.target || d.srcElement;

    d = JSON.parse(target.responseText);

    console.log(d.status);
    console.log(d.err);

    if (d.status === 'err' && d.err === "Not Found") {

      ShopifyApp.Modal.alert({
        title: 'An unexpected error occured',
        message: 'There was an issue saving the metafield. This can happen if you are logged into multiple stores at the same time. Please refresh the page and try saving again. If the problem persists please email jaosn@thebestagency.com.'
      });
      ShopifyApp.Bar.loadingOff();

    } else if (d.status !== 'success') {

      if (d.err === 'Incorrect session detected. Please refresh this page and try again.') {
        ShopifyApp.Modal.alert({
          title: 'Incorrect Session Detected',
          message: 'Please refresh this page and try the action again.'
        });
      } else if (d.err === 'Error: Document Does not Exist') {
        ShopifyApp.Modal.alert({
          title: 'Invalid Custom Object',
          message: 'Please make sure all "custom object" type metafields on this page are assigned to a valid object id.'
        });
      } else {
        ShopifyApp.Modal.alert({
          title: 'An unexpected error occured',
          message: 'Sorry, Something went wrong. Please try this action again or contact jason@thebestagency.com for more help.'
        });
      }
      ShopifyApp.Bar.loadingOff();

    } else {

      ShopifyApp.Bar.loadingOff();
      window.location.reload();

    }
  },
  deleteMetafield: function (e) {
    console.log('deleting metafield');
    var self = this;

    var $this = $(e.currentTarget);
    var id = $this.closest('.card-section').data('metafield-id');

    ShopifyApp.Modal.confirm({
      title: 'Delete Metafield Content',
      message: "Are you sure you want to delete the content in this metafield?",
      okButton: "Yes, delete this content",
      cancelButton: "No, keep this content",
      style: "danger"
    }, function (result) {

      if (result === true) {
        $.ajax({
          url: "/detail/"+window.data.type+'/'+id,
          type: 'DELETE',
          success: function (response) {
            console.log(response);
            window.location.reload();
          }
        });
      }
    });

    return false;
  },
  events: _.extend({}, FormView.prototype.events, {
    'click .save': 'save',
    'click .delete-content': 'deleteMetafield'
  })
});

module.exports = MetafieldsFormView;

}());